import { Text } from "@/components/ui/baseUi/text"
import { BoxOfferFormattedPrice } from "@/modules/boxOffer/components/boxOfferFormSection"
import { cn } from "@/modules/lib/utils"
import { BoxOfferType } from "@modules/boxOffer/entities/boxOfferTypes"
import { LightBoxOfferInfoEntity } from "@modules/boxOffer/entities/lightBoxOfferInfoEntity"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { getReducedProgramPrice } from "@modules/promoCode/utils/promoCodeUtils"
import { ArrowRightIcon } from "lucide-react"

type BoxOfferReductionItemProps = {
  boxOffer: LightBoxOfferInfoEntity
  promoCodeValue?: number
  promoCodeType?: CouponType
  promoCodeDuration?: number
  className?: string
} & React.ComponentProps<"div">

export function BoxOfferReductionItem({
  boxOffer,
  promoCodeValue,
  promoCodeType,
  promoCodeDuration,
  className,
  ...props
}: BoxOfferReductionItemProps) {
  return (
    <div className={cn("mt-2 flex flex-row gap-3", className)} {...props}>
      <div className="flex flex-col gap-2">
        <Text fontStyle="LL">{boxOffer.name}</Text>
        {boxOffer.price && (
          <div className="flex items-center gap-2">
            <BoxOfferFormattedPrice
              price={boxOffer.price}
              showRecurringPeriod={boxOffer.type === BoxOfferType.Subscription}
              recurringPeriod={boxOffer.type === BoxOfferType.Subscription ? boxOffer.recurringPeriod : undefined}
              wholePartStyle="BS"
              decimalPartStyle="BS"
              periodStyle="BS"
            />
            <ArrowRightIcon color="currentColor" className="size-4" />
            <BoxOfferFormattedPrice
              price={getReducedProgramPrice(boxOffer.price, promoCodeValue, promoCodeType)}
              showRecurringPeriod={boxOffer.type === BoxOfferType.Subscription}
              recurringPeriod={boxOffer.type === BoxOfferType.Subscription ? boxOffer.recurringPeriod : undefined}
              wholePartStyle="BS"
              decimalPartStyle="BS"
              periodStyle="BS"
            />
            <Text fontStyle="BS">
              {promoCodeDuration ? word("promoCode.duringXMonths", { count: promoCodeDuration }) : ""}
            </Text>
          </div>
        )}
      </div>
    </div>
  )
}
